










import Vue from 'vue';
import axios from 'axios';
import { IState, Status } from '../store/state';

import StatusMessage from './StatusMessage.vue';
import { unsubscribe } from '../store/actions';

interface UnsubscribeFormComputed {
	link: string;
	text: string;
	buttonText: string;
	hideContent: any;
}

interface UnsubscribeFormMethods {
	ubsubscribe(): void;
}

export default Vue.extend<{}, UnsubscribeFormMethods, UnsubscribeFormComputed, {}>({
	computed: {
		link() {
			return (this.$store.state as IState).config.unsubscribe.unsubscribedUrl;
		},
		text() {
			return (this.$store.state as IState).config.unsubscribe.text;
		},
		buttonText() {
			return (this.$store.state as IState).config.unsubscribe.buttonText;
		},
		hideContent() {
			return {
				'sh-unsubscribe-form__content--hidden': (this.$store.state as IState).status.code === Status.CANCELED
			}
		}
	},
	methods: {
		ubsubscribe(){
			this.$store.dispatch(unsubscribe(undefined));
		}
	},
	components: {
		StatusMessage
	}
})
